
import { FGetPrivileges, FGetPrivilegesInput } from './../../entidades/entidades';
import { CatRolesService } from './../../servicios/cat-roles.service';
import { Component, OnInit } from "@angular/core";
import { PrivilegiosService } from "../../servicios/privilegios.service";
import { CatModulosService } from "../../servicios/cat-modulos.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { FGetPrivilegesService } from '../../servicios/f-get-privileges.service';
@Component({
  selector: 'app-privilegios-a-roles',
  templateUrl: './privilegios-a-roles.component.html',
  styleUrls: ['./privilegios-a-roles.component.css']
})
export class PrivilegiosARolesComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  catModulos: SelectItem[];
  catRoles: SelectItem[];
  // catModulosFiltro: SelectItem[];
  privilegios: FGetPrivileges[]=[];
  privilegiosGlobal: FGetPrivileges[] = [];
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  clonedPrivilegios: { [s: string]: FGetPrivileges } = {};
  idModuloSeleccionado;
  idRolSeleccionado;
  selectedValues: string[] = [];
  constructor(
    private catModulosService: CatModulosService,
    private catRolesService:CatRolesService,
    private fGetPrivilegesService: FGetPrivilegesService
  ) { 

  }

 async  ngOnInit(){
   await  this.getAllCatRoles();
   await  this.getAllPrivilegios();
   await  this.getAllCatModulos();
 
    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
 
      { label: "Guardar", icon: "pi pi-save", command: (event) => { this.guardarGridPrivilegios(); } },
      { label: "Refrescar", icon: "pi pi-refresh", command: (event) => { this.getAllPrivilegios(); } },
 
    ];
   
    this.itemsMenu.push({ label: "Roles", icon: "pi pi-users" });
    this.itemsMenu[2].items=[];
    this.catRoles.forEach(x=>{
      this.itemsMenu[2].items.push({ label: x.label,  command: (event) => { this.seleccionaRol(x.value); } });
    }); 
   this.itemsMenu.push({ label: "Modulos", icon: "pi pi-briefcase" });
    this.itemsMenu[3].items=[];
    this.catModulos.forEach(x=>{

      this.itemsMenu[3].items.push(
        { label: x.label, command: (event) => { this.seleccionaModulo(x.value); } }
      );

    });




    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {
        field: "operacion",
        header: "",
        ordenar: false,
        styleHeader: "width: 60px;",
      },
      {
        field: "Asignado",
        header: "Asignado",
        ordenar: false,
        styleHeader: "width: 80px;",
      },
      { field: "modulo", header: "Modulo", ordenar: true },
      { field: "Rol", header: "Rol", ordenar: true },
      { field: "Privilegio", header: "Privilegio", ordenar: true },
    ];
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let privilegiosEdit = event.data;
    privilegiosEdit.cambio = true;
    privilegiosEdit.baja = false;
  }

  // prettier-ignore
  onEditCancel(event) {
     let privilegiosEdit = event.data;
     let index = this.privilegios.findIndex(
       (obj) => obj.id === privilegiosEdit.id
     );
     this.privilegios[index] = { ...this.clonedPrivilegios[privilegiosEdit.id] };
  }


  // prettier-ignore
  async onEditComplete(event) {
     try {
   
       let privilegiosEdit = event.data
       //Valida si hay cambios
       if (
         privilegiosEdit.id === this.clonedPrivilegios[privilegiosEdit.id].id &&
         privilegiosEdit.asignado === this.clonedPrivilegios[privilegiosEdit.id].asignado 
  
       ) {
         let index = this.privilegios.findIndex((obj) => obj.id === privilegiosEdit.id);
         this.privilegios[index] = { ...this.clonedPrivilegios[privilegiosEdit.id] };
         return;
       }
   
       if (privilegiosEdit.asignado == false && this.clonedPrivilegios[privilegiosEdit.id].asignado){
             privilegiosEdit.baja = true ;
             privilegiosEdit.cambio = false ;
            }
       else {
            privilegiosEdit.baja = false;
            privilegiosEdit.cambio = true;
          }
     } catch (e) {
       this.muestraMensaje.error(e.message, "top", "center");
     } finally {
       console.log("Paso por onEditComplete");
     }
  }

  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore
  async  guardarGridPrivilegios() {
 
    let  lstprivilegios:FGetPrivileges[] = this.privilegiosGlobal.filter((x) => x.baja || x.cambio);
     await this.fGetPrivilegesService.UpdatePrivilegiosRoles(lstprivilegios).toPromise();
     this.getAllPrivilegios();
  }





  // prettier-ignore
  async getAllCatRoles() {
    try {
      const datoRetorno = await this.catRolesService.getAll().toPromise();
      this.catRoles = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });

      this.catRoles.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatModulos");
    }
  }


  async getAllCatModulos() {
    try {
      const datoRetorno = await this.catModulosService.getAll().toPromise();
      this.catModulos = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });

      this.catModulos.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatModulos");
    }
  }

  // prettier-ignore
  async getAllPrivilegios() {
    try {
      this.idModuloSeleccionado=null;
      this.idRolSeleccionado=null;
      let entGetPrivilegios = new FGetPrivilegesInput();
      entGetPrivilegios.pIdModulo = null;
      entGetPrivilegios.pIdPrivilegio = null;
      entGetPrivilegios.pIdRol = null;
      this.privilegios = await this.fGetPrivilegesService.getPrivilegios(entGetPrivilegios).toPromise();
      this.privilegiosGlobal = this.privilegios;
            for (var i = 0, len = this.privilegios.length; i < len; ++i)
        this.clonedPrivilegios[this.privilegios[i].id] = {...this.privilegios[i],        };
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllPrivilegios");
    }
  }

  async seleccionaRol(idRol){
    this.idRolSeleccionado=idRol;
    this.filtraPrivilegios();
  }
  async seleccionaModulo(idModulo){
    this.idModuloSeleccionado=idModulo;
    this.filtraPrivilegios();
  }
  filtraPrivilegios(){
    if (this.idModuloSeleccionado == null && this.idRolSeleccionado != null)
      this.privilegios = this.privilegiosGlobal.filter(x => x.id_rol == this.idRolSeleccionado);
    else if (this.idModuloSeleccionado != null && this.idRolSeleccionado != null)
      this.privilegios = this.privilegiosGlobal.filter(x => x.id_rol == this.idRolSeleccionado && x.id_modulo == this.idModuloSeleccionado);
    else if (this.idModuloSeleccionado != null && this.idRolSeleccionado == null)
      this.privilegios = this.privilegiosGlobal.filter(x => x.id_modulo == this.idModuloSeleccionado);
    else if (this.idRolSeleccionado == null && this.idModuloSeleccionado == null)
      this.privilegios = this.privilegiosGlobal.filter(x => x);
  }
}